// extracted by mini-css-extract-plugin
module.exports = {"theme-dark":"home_theme-dark__WdyDQ","theme-light":"home_theme-light___UWHw"};